import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-card__header"
}
const _hoisted_2 = {
  key: 0,
  class: "app-card__title"
}
const _hoisted_3 = {
  key: 1,
  class: "app-card__actions"
}
const _hoisted_4 = { class: "app-card__body" }
const _hoisted_5 = {
  key: 1,
  class: "app-card__footer"
}

import { computed } from 'vue'

// Define props interface
interface Props {
  title?: string
  hover?: boolean
  flat?: boolean
  border?: boolean
  accent?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | ''
}

// Define props with defaults

export default /*@__PURE__*/_defineComponent({
  __name: 'AppCard',
  props: {
    title: { default: '' },
    hover: { type: Boolean, default: true },
    flat: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    accent: { default: '' }
  },
  setup(__props: any) {

/// <reference types="vue" />
// @ts-ignore
const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['app-card', { 
    'app-card--hover': _ctx.hover,
    'app-card--flat': _ctx.flat,
    'app-card--border': _ctx.border,
    [`app-card--accent-${_ctx.accent}`]: _ctx.accent
  }])
  }, [
    (_ctx.$slots.header || _ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "header"),
          (_ctx.$slots.action)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "action")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})